<template>
	<div>
		<section class="shop ">
			<!-- <div class="tag-partner abo">
				<h2 class="text-center">Vuoi ricevere ordini periodici?</h2>
				<p>Su Quomi puoi anche attivare l’abbonamento per avere tutte le settimane sempre a disposizione lo stesso giorno e orario di consegna. Ti avviseremo appena sarà disponibile il nuovo menù e potrai scegliere tra tante ricette quelle che preferisci. In ogni momento potrai sospendere questa opzione senza vincoli e costi dal tuo profilo.</p>
			</div> -->
			<h2 class="center" v-if="!b2b">La tua spesa in 3 semplici passi!</h2>
			<div class="col-11 col-sm-4 mb-10" style="margin: 0 auto" v-show="b2b && !landingBoxMixed">
				<img src="https://api.quomi.it/oldimg/Cassetta-frutta-large-thumb-big.jpg" alt="">
			</div>
			<h2 class="center" v-if="b2b"><span v-show="landingBoxMixed">Sei un'azienda?</span> Porta il benessere <span v-show="landingBoxMixed">anche</span> in ufficio <br v-show="landingBoxMixed">con le nostre Cassette di Frutta!</h2>
			<div class="flex wrap is-simple-content">
				<div class="col-sm-4 flex flex-column align-items-center">
					<p class="choose-products" :class="{'choose-box-content' : b2b}"></p>
					<h4 class="center" v-html="b2b ? `1. Scegli il contenuto` : `1. Scegli i tuoi prodotti preferiti`" v-if="$root.source != 'bennet'"/>
					<h4 class="center" v-else>1. Scegli i tuoi kit ricette</h4>
					<span 
						class="center"
						v-html="b2b ? `Frutta fresca, succhi e snack salutari <br>per le tue esigenze` : `Fai la tua spesa con kit ricette, <br>cassette di frutta e verdura e <br>tanti prodotti freschi e di qualità`" 
						v-if="$root.source != 'bennet'"
					/>
					<span class="center" v-else>Fai la tua spesa con kit ricette realizzati con prodotti selezionati di alta qualità</span>
				</div>
				<div class="col-sm-4 flex flex-column align-items-center">
					<p class="from-producers" :class="{'to-office' : b2b}" :style="$root.source === 'bennet' ? partnerFrom : ''"></p>
					<h4 class="center" v-html="b2b ? `2. Ricevi tutto in ufficio` : `2. Riceviamo i prodotti dai nostri produttori`" v-if="$root.source != 'bennet'"/>
					<h4 class="center" v-else>2. Ricevi la tua box a casa</h4>
					<span 
					class="center"
					v-html="b2b ? `Ricevi le cassette nel giorno e con la frequenza che preferisci, dove vuoi` : `Riceviamo tutti i prodotti freschi <br>dai nostri produttori selezionati e prepariamo la tua spesa`"
					v-if="$root.source != 'bennet'"
					/>
					<span class="center" v-else>Ricevi comodamente a casa tua la box con il meglio dai nostri produttori selezionati e prodotti a marchio Bennet o di Selezione Gourmet Bennet</span>
				</div>
				<div class="col-sm-4 flex flex-column align-items-center">
					<p class="deliver-orders" :class="{'packaging' : b2b}" :style="$root.source === 'bennet' ? partnerDeliver: ''"></p>
					<h4 class="center" v-html="b2b ? `3. Packaging sostenibile` : `3. Consegniamo la tua spesa a casa`" v-if="$root.source != 'bennet'"/>
					<h4 class="center" v-else>3. Cucina piatti deliziosi</h4>
					<span 
					class="center"
					v-html="b2b ? `Ti forniamo box e cassette idonee al consumo in azienda e riciclabili` : `Scegli il giorno e l'orario di consegna che preferisci e ricevi la tua spesa a casa o presso un punto di ritiro`"
					v-if="$root.source != 'bennet'"
					/>
					<span class="center" v-else>Divertiti a cucinare cene gustose con l’aiuto delle schede ricette complete di ogni passaggio</span>
				</div>
			</div>
		</section>
	</div>
</template>

<script>

export default {
props: {
		b2b: {
			type: Boolean,
			default: false
		},
		landingBoxMixed: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		partnerFrom() {
			return 'background-image: url("https://api.quomi.it/oldimg/box-bennet-instacook.webp");'
		},
		partnerDeliver() {
			return 'background-image: url("https://api.quomi.it/oldimg/cucinare-con-instacook.png");'
		}
	}
}

</script>

<style scoped>
	.content {
		max-width: 1024px;
	}

	.content > section {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		
		margin: 0px auto 30px auto;
	}

	h2 {
		margin-bottom: 30px;
	}

	h3 {
		text-align: center;
	}

	.content > section > div {
		padding: 20px 0px;
		max-width: 470px;
		margin: 0 auto;
	}

	.content > section .image {
		text-align: center;
	}

	.link {
		color: #399ec9;
	}

	.link:hover {
		color: #328fb7;
		text-decoration: underline;
	}

	.icon-contact {
		width: 35px;
		margin-right: 10px;
	}

	.calendar {
		margin: 10px 0;
	}

	.contacts-list {
		list-style: none;
	}

	.contacts-list {
		text-align: left;
		width: 350px;
	}

	.contacts-list li {
		padding: 10px 0;
	}

	.triangle-image {
		background-image: url("https://api.quomi.it/oldimg/AdobeStock_256031852-small-thumb-big.jpg");
		background-position: center center;
	}

	.fa-question-circle {
		color: var(--quomi-primary);
	}

	.choose-products,
	.from-producers,
	.deliver-orders {
		min-width: 300px;
		min-height: 200px;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.choose-products {
		background-image: url("https://api.quomi.it/oldimg/Comefunziona1.png");
	}
	.from-producers {
		background-image: url("https://api.quomi.it/oldimg/Comefunziona2.png");
		background-position: center;
	}
	.deliver-orders {
		background-image: url("https://api.quomi.it/oldimg/Comefunziona3.png");
		background-position: center;
	}

	.choose-box-content {
		width: 76%;
		height: 76%;
		background-image: url("https://api.quomi.it/oldimg/Cassette-di-Frutta-per-l%27ufficio-Quomi.webp");
		background-position: center;
	}
	.to-office {
		background-image: url("https://api.quomi.it/oldimg/Cassette-di-Frutta-per-le-aziende-Quomi.webp");
		background-position: center;
	}
	.packaging {
		background-image: url("https://api.quomi.it/oldimg/Comefunziona2.png");
		background-position: center;
	}
</style>
